import React from 'react';
import logoImg from '../../assets/logo-skip.png';

const FooterComponent = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: '#0F2033',
        color: 'rgba(255,255,255,0.6)',
        padding: '40px 32px 28px',
        fontFamily: 'DM Sans, Helvetica, Arial, sans-serif',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 24,
            marginBottom: 32,
          }}
        >
          {/* Logo + slogan */}
          <div>
            <img
              src={logoImg}
              alt="SkipTheDealerships.ai"
              style={{ height: 36, marginBottom: 12, display: 'block' }}
            />
            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: 'rgba(255,255,255,0.5)',
                lineHeight: 1.6,
                maxWidth: 280,
              }}
            >
              Skip the dealership markup.
              <br />
              Buy smarter. Save thousands.
            </p>
          </div>

          {/* Links */}
          <div style={{ display: 'flex', gap: 48, flexWrap: 'wrap' }}>
            <div>
              <p
                style={{
                  margin: '0 0 12px',
                  fontSize: 11,
                  fontWeight: 700,
                  color: 'rgba(255,255,255,0.3)',
                  letterSpacing: '1.2px',
                  textTransform: 'uppercase',
                }}
              >
                Marketplace
              </p>
              {['Browse Vehicles', 'Post a Listing', 'How It Works', 'Pricing'].map(l => (
                <div key={l} style={{ marginBottom: 8 }}>
                  <a
                    href="#"
                    style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}
                  >
                    {l}
                  </a>
                </div>
              ))}
            </div>
            <div>
              <p
                style={{
                  margin: '0 0 12px',
                  fontSize: 11,
                  fontWeight: 700,
                  color: 'rgba(255,255,255,0.3)',
                  letterSpacing: '1.2px',
                  textTransform: 'uppercase',
                }}
              >
                Company
              </p>
              {/*
                These were all href="#", which is a link that silently does
                nothing rather than a 404 — harder to notice and no better for a
                reader. Blog now points at the route this change adds. The rest
                still have no destination; they are left as they were rather
                than pointed somewhere plausible, so the gap stays visible.
              */}
              {[
                { label: 'About Us', href: '#' },
                { label: 'Dealer Partners', href: '#' },
                { label: 'Contact', href: '#' },
                { label: 'Blog', href: '/blog' },
              ].map(({ label, href }) => (
                <div key={label} style={{ marginBottom: 8 }}>
                  <a
                    href={href}
                    style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}
                  >
                    {label}
                  </a>
                </div>
              ))}
            </div>
            <div>
              <p
                style={{
                  margin: '0 0 12px',
                  fontSize: 11,
                  fontWeight: 700,
                  color: 'rgba(255,255,255,0.3)',
                  letterSpacing: '1.2px',
                  textTransform: 'uppercase',
                }}
              >
                Legal
              </p>
              {[
                ['Terms of Service', '/terms-of-service'],
                ['Privacy Policy', '/privacy-policy'],
                ['PIPEDA Compliance', '#'],
                ['Cookie Policy', '#'],
              ].map(([l, href]) => (
                <div key={l} style={{ marginBottom: 8 }}>
                  <a
                    href={href}
                    style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}
                  >
                    {l}
                  </a>
                </div>
              ))}
            </div>
            <div>
              <p
                style={{
                  margin: '0 0 12px',
                  fontSize: 11,
                  fontWeight: 700,
                  color: 'rgba(255,255,255,0.3)',
                  letterSpacing: '1.2px',
                  textTransform: 'uppercase',
                }}
              >
                Mobile App
              </p>
              <p style={{ margin: '0 0 10px', fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>
                We&apos;re building the app now.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {['iOS', 'Android'].map(platform => (
                  <span
                    key={platform}
                    style={{
                      display: 'inline-block',
                      fontSize: 12,
                      color: 'rgba(255,255,255,0.4)',
                      border: '1px solid rgba(255,255,255,0.15)',
                      borderRadius: 6,
                      padding: '6px 12px',
                    }}
                  >
                    {platform} · Coming soon
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Daily encouragement — sits above the copyright rule, centred and
            deliberately quiet: one shade dimmer than the link columns so it
            reads as a closing note rather than another piece of navigation. */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.08)',
            paddingTop: 24,
            paddingBottom: 4,
            textAlign: 'center',
          }}
        >
          <p
            style={{
              margin: '0 0 8px',
              fontSize: 11,
              fontWeight: 700,
              color: 'rgba(255,255,255,0.28)',
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
            }}
          >
            Daily Encouragement · Philippians 4:13
          </p>
          <p
            style={{
              margin: '0 auto',
              maxWidth: 420,
              fontSize: 13,
              fontStyle: 'italic',
              color: 'rgba(255,255,255,0.42)',
              lineHeight: 1.7,
            }}
          >
            “I can do all things through Christ who strengthens me.”
          </p>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.08)',
            marginTop: 24,
            paddingTop: 20,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <p style={{ margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.25)' }}>
            © {year} SkipTheDealerships.ai · Drivana Technologies Inc. · Manitoba, Canada
          </p>
          <div style={{ display: 'flex', gap: 16 }}>
            {[
              {
                label: 'Facebook',
                href: 'https://facebook.com/skipthedealerships',
                svg: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                  </svg>
                ),
              },
              {
                label: 'X',
                href: 'https://x.com/skipthedealerships',
                svg: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                ),
              },
              {
                label: 'YouTube',
                href: 'https://youtube.com/@skipthedealerships',
                svg: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
                  </svg>
                ),
              },
            ].map(({ label, href, svg }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                style={{
                  color: 'rgba(255,255,255,0.35)',
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={e => (e.currentTarget.style.color = '#1A9E85')}
                onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.35)')}
              >
                {svg}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
